import "./styles.css"; // CSS below

export const Dropdown = ({ selectedOption, options, onSelect }) => {
  return (
    <div className="dropdown-menu">
      {options.map((opt) => (
        <div
          key={opt}
          onClick={() => onSelect(opt)}
          className={`dropdown-item ${selectedOption === opt ? "selected" : ""}`}
        >
          {opt}
        </div>
      ))}
    </div>
  );
};
